export default function DesignPlusBadge() {
  return (
    <a
      data-testid="design-plus-badge"
      href="https://designplususa.com"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-[9999] inline-flex items-center h-10 px-5 rounded-full bg-[#0F1A14] hover:bg-[#15803D] text-white text-xs sm:text-sm font-semibold shadow-[0_8px_24px_-8px_rgba(0,0,0,0.4)] transition-colors"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <span className="whitespace-nowrap">
        Designed &amp; Developed by{" "}
        <span className="text-[#DC2626] font-bold">Design Plus</span>
      </span>
    </a>
  );
}
